function SessionStorageManager() {
    var self = this;

    self.supported = true;

    if (typeof (Storage) == "undefined")
        self.supported = false;         //No local storage    

    //properties	
    self.set = function (key, value) {
        if (!self.supported)
            return;       
        sessionStorage.setItem(key, value);
    };

    self.get = function (key) {
        if (!self.supported)
            return;      
        return sessionStorage[key];
    };

    self.setObject = function (key, value) {
        if (!self.supported)
            return;
        sessionStorage.setItem(key, JSON.stringify(value));
    };

    self.getObject = function (key) {
        if (!self.supported)
            return;
        var value = this.getItem(key);
        return value && JSON.parse(value);        
    };
	
	self.remove = function(key){
		if(!self.supported)
			return;
		sessionStorage.removeItem(key);
	};
}

module.exports = SessionStorageManager;